import axios from 'axios';

const API_URL = '/api/exit-strategy';

// Configure axios to send credentials with requests
axios.defaults.withCredentials = true;

const exitStrategyService = {
  /**
   * Generate exit strategy analysis
   */
  async generateAnalysis(exitPath, targetAmount, targetDate) {
    try {
      const response = await axios.post(`${API_URL}/generate`, {
        exit_path: exitPath,
        target_amount: targetAmount,
        target_date: targetDate
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to generate analysis'
      };
    }
  },

  /**
   * Get saved analysis
   */
  async getAnalysis() {
    try {
      const response = await axios.get(`${API_URL}/analysis`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to get analysis'
      };
    }
  },

  /**
   * Save exit strategy
   */
  async saveAnalysis(exitPath, analysisText, targetAmount, targetDate) {
    try {
      const response = await axios.post(`${API_URL}/save`, {
        exit_path: exitPath,
        analysis_text: analysisText,
        target_amount: targetAmount,
        target_date: targetDate
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to save analysis'
      };
    }
  }
};

export default exitStrategyService;
